function getAddresses() {
  return this.state.addresses;
}

module.exports = getAddresses;
